<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
          [{"num_cand":"U2FsdGVkX19rlNnbDgwX720yAOBoZjzGZgG9WSyZXj0=","cpf":"U2FsdGVkX18Up1QpVCSjbr2QfjrfAe6F9MLFrgbbQLU="},{"num_cand":"U2FsdGVkX1/w8zZgiWVTzYmJykhViRcLs65mw1Ab6Qk=","cpf":"U2FsdGVkX19tDHUFEI8mH5pxlsqKqBaEAYqJ8M1UPfE="},{"num_cand":"U2FsdGVkX18+RVFy8TFBFl+VMT19UL0laZlj3tdMKLw=","cpf":"U2FsdGVkX1/NL3N+5IooIsz0Tere/mS/Rb37MbQ5xOI="},{"num_cand":"U2FsdGVkX19UWsQBgimWuaXOBjoTunG8meoTwheLlac=","cpf":"U2FsdGVkX18aaiW2yp7RxBlNTqbCSCKeSn485uid/hI="},{"num_cand":"U2FsdGVkX18rbaH4+G06ZIlnTFcgn9xRS0iQwUX0reE=","cpf":"U2FsdGVkX19MSrX383IjijJO4RbMAV/w4Ry2VhpcP5U="},{"num_cand":"U2FsdGVkX1/LvK+9YD9cE+hAhMicAHIGk+kGzUpYNE0=","cpf":"U2FsdGVkX1+etEFU5dcmkBz/zs41bPzv1FejsN/Nk60="},{"num_cand":"U2FsdGVkX19U/W7WwiGvdz5+BeV8WxCRrZgvysvUIIc=","cpf":"U2FsdGVkX18gvBafLpnx4TRTCSBBuvwhrSYJo2osFOA="},{"num_cand":"U2FsdGVkX19FfHw4S8LG6xcGgZGZXBP8d2xyW6Is/Vk=","cpf":"U2FsdGVkX1/+oaMeUd3+sje1YuFzwKd4YoDV7oYs+4Y="},{"num_cand":"U2FsdGVkX1/4fKQm6npfCcVnoY0GULPdycvqdr3A/wg=","cpf":"U2FsdGVkX18+q/Os/6ecoYpFkze1b91CFuLhqBmeaJA="},{"num_cand":"U2FsdGVkX1/sAM/+9QpUffkHe5GoAi7x9edC6ncUuK8=","cpf":"U2FsdGVkX1/FcO72wX6vl9s3hpHxpyeeYakA8FvB6gs="},{"num_cand":"U2FsdGVkX18hAwI6xYfy4X3Vx4h/VJJNr7bA+a5zxuc=","cpf":"U2FsdGVkX19myAgl9TwVEm0nmuexJ1FTZA8t0sLWk/M="},{"num_cand":"U2FsdGVkX1/46fX4bYjOwoHfmJ7qH4QXsXNHIhQLOFA=","cpf":"U2FsdGVkX1+3lyKidOH2HNvs+BN2ri61FbDM7ep2mgk="},{"num_cand":"U2FsdGVkX18eWDZ15NpdkiJrOoRi6vw6smc/BMvnPGw=","cpf":"U2FsdGVkX19pF39QtoxYQJ7p/5+6Awvr3NAyXOIh7d8="},{"num_cand":"U2FsdGVkX19lrjx6NTTLS0ZEDIn+iF/5OV0ake9f04Y=","cpf":"U2FsdGVkX1+SxprpLBDexsJUQ2lZhbeX5vPYXhVFvBo="},{"num_cand":"U2FsdGVkX199Ub8snXSTQnFQ3YNsiXCZNjHl8tlRuag=","cpf":"U2FsdGVkX19j/LSBBjorOCggwWZzLQlv2eN/6zlmXss="},{"num_cand":"U2FsdGVkX18KDsaT8NqjJ2uiSt6/i7lWW4N7HmbIa6k=","cpf":"U2FsdGVkX1+2prltZglnXZSsGMElD3bQtaWqihDzFAY="},{"num_cand":"U2FsdGVkX1+13y0nwJPiBf2fdUQTTJYxshLsvq3VdSw=","cpf":"U2FsdGVkX1+jEXeQ52SGuQT/nGQpTe75tuyVWHIlbzQ="},{"num_cand":"U2FsdGVkX1+qY8dV+7JoUMjELHyzJCUhidCHUoLBoIQ=","cpf":"U2FsdGVkX18jeY3BcZ63jAqaP0SQHqBfuIII4lfoIRE="},{"num_cand":"U2FsdGVkX197cQGnCtN18buEF/TqNelsSuE2tOMk5A0=","cpf":"U2FsdGVkX1/On97s4W2SbMNua+SGMDDb+H7pKqqub3Y="},{"num_cand":"U2FsdGVkX1/dDwbelARG2pTYbesKlCNEpa7OCKVZ3iM=","cpf":"U2FsdGVkX1+Baf8gim3Ea13aMb4tHGUYaKcFzQkDUZM="},{"num_cand":"U2FsdGVkX1/oVJoDRtyeAYbTVymrfK/xsP8Nxb2yS2Y=","cpf":"U2FsdGVkX1/RqmlNBs3MyHM39tqmEuiZsPGQg6v/pUA="},{"num_cand":"U2FsdGVkX18/vyHT2ACeacws0cKjPTlmUh3F+GNuWWs=","cpf":"U2FsdGVkX1/gX5uf69iaklzLkyi9L4wziK1c96kBW00="},{"num_cand":"U2FsdGVkX193IDdFMLcnLiAo1soaSBHuG1xnK+EiCA8=","cpf":"U2FsdGVkX1/BlZxb8PqCFH9+y4Ttf7IspAJ6vcokay0="},{"num_cand":"U2FsdGVkX19+CZ/vMvhgJSyD75jQaS/W5JYxUMC2/RA=","cpf":"U2FsdGVkX1821IfkTsDsGCB+gJL3Md5siDDDZJ5FABk="}];


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2205/rec_tit/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
